const trans = require('@spotahome/soyuz/client').trans;

const TRANS_DELIMITER = '_';

const TranslatorService = function TranslatorService(translator) {
  this.translator = translator;
};

// eslint-disable-next-line func-names
TranslatorService.prototype.trans = function(key, domain, parameters, locale) {
  let message;
  if (this.translator) {
    message = this.translator.trans(key, parameters, domain, locale);
  } else {
    message = key;
  }
  return message;
};

TranslatorService.prototype.transChoice = function transChoice(
  key,
  number,
  domain,
  parameters,
  locale
) {
  let message;
  if (this.translator) {
    message = this.translator.transChoice(
      key,
      number,
      parameters,
      domain,
      locale
    );
  } else {
    message = key;
  }
  return message;
};

TranslatorService.prototype.getPickerI18N = function getPickerTrans() {
  let pickerI18N;
  if (this.translator) {
    pickerI18N = {
      previousMonth: this.translator.trans('pikaday.label.previous_month'),
      nextMonth: this.translator.trans('pikaday.label.next_month'),
      months: this.translator
        .trans('pikaday.label.months')
        .split(TRANS_DELIMITER),
      weekdays: this.translator
        .trans('pikaday.label.weekdays')
        .split(TRANS_DELIMITER),
      weekdaysShort: this.translator
        .trans('pikaday.label.weekdays_short')
        .split(TRANS_DELIMITER)
    };
  } else {
    pickerI18N = {};
  }
  return pickerI18N;
};

TranslatorService.prototype.getCurrentLocale = function getLocale() {
  return this.translator ? this.translator.locale : 'en';
};

// module.exports = new TranslatorService(window['Translator']);
module.exports = new TranslatorService({ trans });
